module.exports = __webpack_public_path__ + "img/eth_pan_temps_web.ce9c0cfe.jpg";